import React from 'react';
import "./Contact.css"
import {MdCall} from 'react-icons/md';
// import {hiChatBubbleBottomCenter } from "react-icons/hi2";
import { BsFillChatDotsFill } from "react-icons/bs";

const Contact = ({refProp}) => {
  return (
    <section ref={refProp}> 
    <section className='c-wrapper'>
    <div className="c-container">
        <div className="c-left">
        <span className="orange">Our Contact </span>
          <span className="secondary">Easy to contact us</span>
          <span className="secondaryText">
            We always ready to help by providijng the best services for you. We
            beleive a good blace to live can make your life better{" "}
        </span>
        <div className=" contactModes">
            <div className=" row">
              <div className=" mode">
                <div className="flexStart">
                  <div className=" icon">
                    <MdCall size={29} />
                  </div>
                  <div className=" detail">
                    <span className="primary">Call</span>
                    <span className="secondary">021 123 145 14</span>
                  </div>
                </div>
                <div className=" button">Call now</div>
            </div>
            </div>

            <div className=" mode">
                <div className="flexStart">
                  <div className=" icon">
                    <BsFillChatDotsFill size={29} />
                  </div>
                  <div className=" detail">
                    <span className="primary">Chat</span>
                    <span className="secondary">021 123 145 14</span>
                  </div>
                </div>
                <div className="button">Chat now</div>
              </div>
            </div>

        </div>
        <div className="c-right">
        <img src="./main4.jpg" alt="m" />
        </div>

    </div>

    </section>
    </section>

  )
}

export default Contact
